function r(o,n){try{const t=new URL(o);return t.hostname=n,t.protocol="https",t.port="",t.toString()}catch{return console.error("Invalid URL:",o),o}}export{r as replaceDomain};
//# sourceMappingURL=replace-domain.js.map
